module.exports = __webpack_public_path__ + "static/media/Quiz_Card_Big.b489b2cd.png";